/*
|--------------------------------------------------------------------------
| Lunelle Wellness
| Collection API
|--------------------------------------------------------------------------
|
| Handles AJAX loading of Collection Hub content.
|
| Responsibilities
|
| • Filters
| • Sorting
| • Pagination
| • Browser History
| • Section Rendering
|
| Does NOT handle
|
| • Cart
| • Quick View
| • Product Cards
|
|--------------------------------------------------------------------------
*/

window.Lunelle = window.Lunelle || {};

Lunelle.ProductAPI = class {

    constructor(options = {}) {

        this.feedSelector =
            options.feedSelector || "#LwHubFeed";

        this.sidebarSelector =
            options.sidebarSelector || "#LwHubSidebar";

        this.loadingClass =
            options.loadingClass || "is-loading";

        this.feed =
            document.querySelector(this.feedSelector);

    }

    /*
    |--------------------------------------------------------------------------
    | Public
    |--------------------------------------------------------------------------
    */

    async load(url, pushState = true) {

        if (!this.feed) {
            return;
        }

        this.showLoading();

        try {

            const requestURL = new URL(
                url,
                window.location.origin
            );

            requestURL.searchParams.set(
                "section_id",
                "lw-product-hub"
            );


            if (pushState) {

                history.pushState(
                    {},
                    "",
                    url
                );

            }

            const html =
                await Lunelle.Utils.fetchHTML(
                    requestURL.toString()
                );

            this.replaceContent(html);

        }

        catch (error) {

            console.error(
                "Product API:",
                error
            );

            this.showError(error);

        }

        finally {

            this.hideLoading();

        }

    }

    /*
    |--------------------------------------------------------------------------
    | Replace Content
    |--------------------------------------------------------------------------
    */

    replaceContent(html) {

        const parser =
            new DOMParser();

        const documentHTML =
            parser.parseFromString(
                html,
                "text/html"
            );

        /*
        ----------------------------------------------------------
        Replace Feed
        ----------------------------------------------------------
        */

        const replacementFeed =
            documentHTML.querySelector(
                this.feedSelector
            );

        if (
            replacementFeed &&
            this.feed
        ) {

            this.feed.replaceWith(replacementFeed);

            this.feed = replacementFeed;

        }

        /*
        ----------------------------------------------------------
        Replace Sidebar
        ----------------------------------------------------------
        */

        const replacementSidebar =
            documentHTML.querySelector(
                this.sidebarSelector
            );

        const currentSidebar =
            document.querySelector(
                this.sidebarSelector
            );

        if (
            replacementSidebar &&
            currentSidebar
        ) {

            currentSidebar.replaceWith(
                replacementSidebar
            );

        }

        /*
        ----------------------------------------------------------
        Notify Components
        ----------------------------------------------------------
        */

        document.dispatchEvent(
            new CustomEvent(
                "lunelle:collection:updated",
                {
                    detail: {
                        feed: this.feed
                    }
                }
            )
        );

        /*
        ----------------------------------------------------------
        Scroll to Toolbar
        ----------------------------------------------------------
        */

        requestAnimationFrame(() => {

            const toolbar = document.querySelector(".lw-toolbar");

            if (!toolbar) {
                return;
            }

            const header = document.querySelector(".section-header");

            const headerHeight = header ? header.offsetHeight : 0;

            const y =
                toolbar.getBoundingClientRect().top +
                window.pageYOffset -
                headerHeight -
                16;

            window.scrollTo({
                top: y,
                behavior: "smooth"
            });
        });
    }

    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    showLoading() {

        this.feed.classList.add(this.loadingClass);

        if (!this.feed) {
            return;
        }

        this.feed.classList.add(
            this.loadingClass
        );

    }

    hideLoading() {

        if (!this.feed) {
            return;
        }

        this.feed.classList.remove(
            this.loadingClass
        );

    }

    /*
    |--------------------------------------------------------------------------
    | Error
    |--------------------------------------------------------------------------
    */

    showError(error) {

        console.error(error);

    }

    /*
|--------------------------------------------------------------------------
| Append Products (Load More)
|--------------------------------------------------------------------------
*/

async append(
    url,
    options = {}
) {
    const scrollToNewProducts = options.scrollToNewProducts ?? true;

    const grid =
        document.querySelector("#product-grid");

    const loadMore =
        document.querySelector("#LwLoadMore");

    if (!grid || !loadMore) {
        return;
    }

    loadMore.classList.add("is-loading");

    const toolbarButton = document.querySelector("[data-load-more-toolbar]");

    if (toolbarButton) {
        toolbarButton.classList.add("is-loading");
        toolbarButton.dataset.originalText = toolbarButton.textContent;

        toolbarButton.textContent = "Loading…";
    }

    const bottomButton = loadMore.querySelector(".lw-load-more__button");

    if (bottomButton) {
        bottomButton.dataset.originalText = bottomButton.textContent;

        bottomButton.textContent = "Loading…";
    }

    try {

        const requestURL =
            new URL(
                url,
                window.location.origin
            );

        requestURL.searchParams.set(
            "section_id",
            "lw-product-hub"
        );

        const html =
            await Lunelle.Utils.fetchHTML(
                requestURL.toString()
            );

        const documentHTML =
            Lunelle.Utils.parseHTML(html);

            /*
        ----------------------------------------------------------
        Replace Toolbar
        ----------------------------------------------------------
        */

        const newToolbar =
            documentHTML.querySelector(".lw-toolbar");

        const currentToolbar =
            document.querySelector(".lw-toolbar");

        if (
            newToolbar &&
            currentToolbar
        ) {

            currentToolbar.replaceWith(
                newToolbar
            );

        }

        /*
        ----------------------------------------------------------
        Append new products
        ----------------------------------------------------------
        */

        let firstNewItem = null;

        const newItems =
            documentHTML.querySelectorAll(
                "#product-grid > *"
            );

        newItems.forEach(item => {

            if (!firstNewItem) {
                firstNewItem = item;
            }

            grid.appendChild(item);

        });

        /*
        ----------------------------------------------------------
        Replace Load More
        ----------------------------------------------------------
        */

        const newLoadMore =
            documentHTML.querySelector("#LwLoadMore");

        if (newLoadMore) {

            loadMore.replaceWith(
                newLoadMore
            );

        } else {

            loadMore.remove();

        }

        if (scrollToNewProducts && firstNewItem) {

            requestAnimationFrame(() => {

                const header = document.querySelector(".section-header");
                const headerHeight = header ? header.offsetHeight : 0;

                const y =
                    firstNewItem.getBoundingClientRect().top +
                    window.pageYOffset -
                    headerHeight -
                    24;

                window.scrollTo({
                    top: y,
                    behavior: "smooth"
                });
            });
        }

        /*
        ----------------------------------------------------------
        Wake everything back up
        ----------------------------------------------------------
        */

        document.dispatchEvent(

            new CustomEvent(
                "lunelle:collection:updated"
            )

        );

    } catch (error) {

        console.error(
            "Collection Append:",
            error
        );

    }

}

};